/* eslint-disable no-restricted-syntax */

import {ICountry} from 'typescript/models/Country';

export const countryAcronymHash = (countries: ICountry[]) => {
  const countryHash: {[key: string]: {name: string; flag: string}} = {};

  for (const key in countries) {
    if (!countryHash[countries[key].country]) {
      countryHash[countries[key].country] = {name: countries[key].alpha3Code, flag: countries[key].flag};
    }
  }

  return countryHash;
};
